import { FC, ReactNode } from "react";
import { MarkdownV1SessionPart, SessionEventKind } from "../session.types";
import styled from "@emotion/styled";
import { MDSSessionPartContainer } from "@/mds/components/sessions/session-parts/session-part.style";
import { SessionPartContext } from "@/mds/components/sessions/session-parts/session-part.types";
import { MDSBubble } from "@/mds/components/bubble/bubble";
import { MDSBubbleAlignment, MDSBubbleVariant } from "@/mds/components/bubble/bubble.types";
import { MemCommonMarkdown, OnClickMemItem, syntaxTreeModule } from "@mem-labs/common-editor";

interface Props {
  part: MarkdownV1SessionPart;
  context: SessionPartContext;
}

export const MDSSessionMarkdownV1Part: FC<Props> = ({ part, context }) => {
  const WrapperComponent: FC<IWrapperComponentProps> = (() => {
    if (context.event_kind === SessionEventKind.AgentActionV1) {
      return AgentActionWrapper;
    }

    return StandardWrapper;
  })();

  const onClickHandler: OnClickMemItem = (_kind, _id, _target) => {
    // TODO.
    // alert(`${kind} ${id} ${target}`);
  };

  // Convert MDX to standard Markdown for proper link parsing
  const content = syntaxTreeModule.convertMdxToMarkdown({
    mdxContent: part.content,
  });

  return (
    <WrapperComponent isLastInGroup={context.isLastInGroup}>
      <Container event_kind={context.event_kind}>
        <MarkdownContent onClickMemItem={onClickHandler}>{content}</MarkdownContent>
      </Container>
    </WrapperComponent>
  );
};

interface IWrapperComponentProps {
  children: ReactNode;
  isLastInGroup?: boolean;
}

const AgentActionWrapper: FC<IWrapperComponentProps> = ({ children }) => {
  return <>{children}</>;
};

const StandardWrapper: FC<IWrapperComponentProps> = ({ children, isLastInGroup }) => {
  return (
    <Bubble
      variant={MDSBubbleVariant.Grey}
      align={MDSBubbleAlignment.Right}
      isLastInGroup={isLastInGroup}
    >
      {children}
    </Bubble>
  );
};

const Bubble = styled(MDSBubble)`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.xxs};
  margin-bottom: ${({ theme }) => theme.spacing.xxs};
  margin-right: 0;
`;

const Container = styled(MDSSessionPartContainer)<{
  event_kind: SessionEventKind;
}>`
  align-items: center;
  margin-top: ${({ theme, event_kind }) =>
    event_kind === SessionEventKind.AgentActionV1 ? theme.spacing.xs : "0"};
  margin-bottom: ${({ theme, event_kind }) =>
    event_kind === SessionEventKind.AgentActionV1 ? theme.spacing.xs : "0"};
`;

const MarkdownContent = styled(MemCommonMarkdown)(({ theme }) => ({
  width: "100%",
  color: theme.colors.grey.x600,
}));
